import axios from "utils/axiosConfig";
import uri from "../config";
import { getConfig } from "../auth/authService";

const API_URL = uri;

// Get user's credit balance
const getCredits = async (email) => {
  const response = await axios.get(
    `${API_URL}/api/credits/${email}`,
    getConfig()
  );
  return response.data;
};

// Get all available credit packages
const getPackages = async () => {
  const response = await axios.get(`${API_URL}/api/credits/packages`);
  return response.data;
};

// Purchase a credit package
const purchaseCredits = async ({
  email,
  packageId,
  paymentMethod,
  idempotencyKey = null,
}) => {
  const config = getConfig();
  if (idempotencyKey) {
    config.headers["X-Idempotency-Key"] = idempotencyKey;
  }
  const response = await axios.post(
    `${API_URL}/api/credits/purchase`,
    {
      email,
      packageId,
      paymentMethod,
    },
    config
  );
  return response.data;
};

// Spend credits for an order
const spendCredits = async ({ email, amount, orderId, description }) => {
  const response = await axios.post(
    `${API_URL}/api/credits/spend`,
    {
      email,
      amount,
      orderId,
      description,
    },
    getConfig()
  );
  return response.data;
};

// Get credit transaction history
const getHistory = async ({ email, limit, skip }) => {
  const response = await axios.get(
    `${API_URL}/api/credits/history/${email}?limit=${limit || 20}&skip=${
      skip || 0
    }`,
    getConfig()
  );
  return response.data;
};

// Reward loyalty credits
const rewardCredits = async ({ email, amount, description }) => {
  const response = await axios.post(
    `${API_URL}/api/credits/reward`,
    {
      email,
      amount,
      description,
    },
    getConfig()
  );
  return response.data;
};

export const creditsService = {
  getCredits,
  getPackages,
  purchaseCredits,
  spendCredits,
  getHistory,
  rewardCredits,
};
